import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import CardComponent from "./CardComponent";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import customIconUrl from "./map_sunu2.png"; // Import your custom icon

// Fix the default marker icon issue in React-Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const customIcon = new L.Icon({
  iconUrl: customIconUrl,
  iconSize: [35, 35], // Size of the icon
  iconAnchor: [17, 35], // Point of the icon which will correspond to marker's location
  popupAnchor: [0, -35], // Point from which the popup should open relative to the iconAnchor
});

const MapComponent = () => {
  // Set your desired coordinates and zoom level
  const position = [51.505, -0.09];
  const zoom = 13;

  // Custom marker icon
  const customIcon = new L.Icon({
    iconUrl: "path-to-your-icon/map_sunu2.png", // Make sure to provide the correct path
    iconSize: [38, 95], // Size of the icon
    iconAnchor: [22, 94], // Point of the icon which will correspond to marker's location
    popupAnchor: [-3, -76], // Point from which the popup should open relative to the iconAnchor
  });

  return (
    <MapContainer
      center={position}
      zoom={zoom}
      style={{ height: "100%", width: "100%" }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <Marker position={position} icon={customIcon}>
        <Popup>
          <CardComponent />
        </Popup>
      </Marker>
    </MapContainer>
  );
};

export default MapComponent;
